<template>
  <Transition name="preferred-shipping-modal-overlay">
    <div
      v-if="visible"
      class="preferred-shipping-modal-overlay preferred-shipping-modal-overlay--glass"
      @click.self="$emit('cancel')"
    >
      <Transition name="preferred-shipping-modal-panel" appear>
        <div
          v-if="visible"
          class="preferred-shipping-modal-card preferred-shipping-modal-card--glass"
          role="dialog"
          aria-modal="true"
          aria-labelledby="preferred-shipping-modal-title"
          @click.stop
        >
          <div class="preferred-shipping-modal-header preferred-shipping-modal-header--glass">
            <h2 id="preferred-shipping-modal-title" class="preferred-shipping-modal-title">
              Shipping Method
            </h2>
            <button
              type="button"
              class="preferred-shipping-modal-close-btn"
              aria-label="Close"
              title="Close"
              :disabled="saving"
              @click="$emit('cancel')"
            >
              <i class="bi bi-x-lg" aria-hidden="true"></i>
            </button>
          </div>

          <div class="preferred-shipping-modal-body preferred-shipping-modal-body--glass">
            <LabelInputField
              input-id="preferred-shipping-name"
              label="Name"
              v-model="name"
              placeholder="e.g. FedEx Ground"
              required
              flex
              :has-error="!!fieldError"
              :disabled="saving"
              @input="fieldError = ''"
            />
            <LabelInputField
              input-id="preferred-shipping-description"
              label="Description"
              v-model="description"
              placeholder="e.g. Standard ground delivery"
              required
              flex
              :has-error="!!fieldError"
              :disabled="saving"
              @input="fieldError = ''"
            />
            <div v-if="fieldError" class="preferred-shipping-modal-error">{{ fieldError }}</div>
          </div>

          <div class="preferred-shipping-modal-actions preferred-shipping-modal-actions--glass">
            <SecondaryButton label="Cancel" :disabled="saving" @click="$emit('cancel')" />
            <PrimaryButton label="Save" :loading="saving" @click="submit" />
          </div>
        </div>
      </Transition>
    </div>
  </Transition>

  <ErrorModal
    :show="showErrorModal"
    title="Error"
    :message="errorMessage"
    buttonText="OK"
    @close="closeErrorModal"
  />
</template>

<script>
import '@/modules/vendor/styles/AddPreferredShippingMethod.css';
import ApiService from '@/services/api.service.js';
import logger from '@/utils/logger';
import ErrorModal from '@/components/ErrorModal.vue';
import LabelInputField from '@/modules/consultant/components/LabelInputField.vue';
import PrimaryButton from '@/modules/consultant/components/PrimaryButton.vue';
import SecondaryButton from '@/modules/consultant/components/SecondaryButton.vue';

export default {
  name: 'AddPreferredShippingMethod',
  components: {
    ErrorModal,
    LabelInputField,
    PrimaryButton,
    SecondaryButton,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    companyId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      name: '',
      description: '',
      saving: false,
      fieldError: '',
      showErrorModal: false,
      errorMessage: '',
    };
  },
  watch: {
    visible(val) {
      if (!val) {
        this.name = '';
        this.description = '';
        this.fieldError = '';
        this.showErrorModal = false;
        this.errorMessage = '';
        this.saving = false;
      }
    },
  },
  methods: {
    async submit() {
      if (!this.name.trim() || !this.description.trim()) {
        this.fieldError = 'Both fields are required.';
        return;
      }

      this.saving = true;
      this.fieldError = '';
      try {
        const method = await ApiService.createPreferredShippingMethod({
          name: this.name.trim(),
          description: this.description.trim(),
          companyId: this.companyId,
        });

        this.name = '';
        this.description = '';
        this.$emit('ok', method);
        logger.log('Preferred shipping method created:', method?.name);
      } catch (err) {
        logger.error('Error creating shipping method:', err);
        this.errorMessage =
          err.response?.data?.error ||
          err.response?.data?.message ||
          err.message ||
          'Failed to create shipping method.';
        this.showErrorModal = true;
      } finally {
        this.saving = false;
      }
    },

    closeErrorModal() {
      this.showErrorModal = false;
      this.errorMessage = '';
    },
  },
};
</script>
